import { Head, Link } from "@inertiajs/react"
import Navbar from "@/components/chalky/Navbar"
import Footer from "@/components/chalky/Footer"

interface IndexCard {
  key: string
  label: string
  count: number
  path: string
}

interface DashboardProps {
  account: { email_address: string }
  indexes: IndexCard[]
  paths: { sign_out: string }
  i18n: {
    title: string
    welcome: string
    indexes_title: string
    entries: string
    empty_state: string
    sign_out: string
  }
}

export default function Dashboard({ indexes, paths, i18n }: DashboardProps) {
  return (
    <>
      <Head>
        <title>{`${i18n.title} — Chalky Chrono Finish`}</title>
      </Head>

      <div className="bg-[#0a0a0f] min-h-screen text-slate-300 flex flex-col">
        <Navbar />

        <main className="flex-1 px-6 pt-32 pb-24">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center justify-between gap-4 mb-10 flex-wrap">
              <div>
                <h1 className="text-3xl font-bold text-white">{i18n.title}</h1>
                <p className="text-slate-400 mt-1">{i18n.welcome}</p>
              </div>
              <Link
                href={paths.sign_out}
                method="delete"
                as="button"
                className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-semibold text-white bg-white/10 border border-white/20 rounded-full hover:bg-red-500/20 hover:border-red-500/40 hover:text-red-200 transition-colors"
              >
                <i className="fa-solid fa-right-from-bracket" aria-hidden="true" />
                {i18n.sign_out}
              </Link>
            </div>

            <h2 className="text-sm font-medium uppercase tracking-widest text-violet-400/80 mb-4">
              {i18n.indexes_title}
            </h2>

            {indexes.length === 0 ? (
              <div className="bg-white/[0.03] border border-white/[0.07] rounded-2xl p-10 text-center">
                <p className="text-slate-400">{i18n.empty_state}</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {indexes.map((index) => (
                  <Link
                    key={index.key}
                    href={index.path}
                    className="group bg-white/[0.03] border border-white/[0.07] rounded-2xl p-6 hover:border-violet-500/40 hover:bg-white/[0.05] transition-colors"
                  >
                    <div className="flex items-baseline justify-between">
                      <h3 className="text-lg font-bold text-white group-hover:text-violet-300 transition-colors">
                        {index.label}
                      </h3>
                      <span className="text-2xl font-bold text-violet-400">{index.count}</span>
                    </div>
                    <p className="text-xs text-slate-500 mt-1">{i18n.entries}</p>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </main>

        <Footer />
      </div>
    </>
  )
}
